export const VOTE_URL = "//vote.afreecatv.com";
export const BJ_URL = "//bj.afreecatv.com";
export const BJ_PROTOCAL_URL = (() => {
	const url = new URL(window.location.href);
	return url.protocol + BJ_URL;
})();

export const TYPE_DEFAULT = "1";
export const TYPE_BATTLE = "2";
export const TYPE_BATTLE_DRAW = "3";

export const STATUS_VOTING = 1; //투표진행중
export const STATUS_CLOSE = 100; //투표종료

export const MODE_CREATE = "create";
export const MODE_VIEW = "view";
